import { SHIPMENT_SERVICE_OPTIONS } from "../../constants";
import { MultiSelect } from "../Select";

import type { SelectProps } from "@mui/material";

interface Props {
  onChange: (value: string[]) => void;
  defaultValue?: string[];
  label: string;
  value?: string[];
  width?: string | number;
  customOptions?: EquipmentOption[];
  selectProps?: SelectProps;
}

export function ShipmentServiceMultiSelect(props: Props) {
  const {
    onChange,
    defaultValue = [],
    value,
    label,
    width,
    customOptions,
    selectProps,
  } = props;

  return (
    <MultiSelect
      inputLabel={label}
      defaultValue={defaultValue}
      value={value}
      onChange={onChange}
      options={customOptions ?? SHIPMENT_SERVICE_OPTIONS}
      width={width}
      selectProps={selectProps}
    />
  );
}
